export default {
  computed: {
    isLamOwner() {
      return !!this.agent && this.agent.key === this.$route.params.ak
        && ((!!this.$route.params.uk
          && this.$route.params.uk == this.lam.agentuserkey)
          || !this.$route.params.uk);
    },
  },
  methods: {
    logLeadEvent(action, section) {
      const leadEventData = {
        leadid: this.lead.id,
        agentid: this.lam.agentid,
        // agentid: this.agent.id,
        userkey: !!this.user && !!this.user.key ? this.user.key : this.agent.userkey,
        sourcetypeid: this.isLamOwner ? 1 : 5,
        leadeventsource: 'Agent Portal',
        leadeventsourcesection: section,
        leadeventaction: action,
        oldvalue: '',
        newvalue: '',
      };
      return this.$apiServices.oa.lead.sendLeadEvent(leadEventData);
    },
    // gaEvent(eventAction, eventCategory) {
    //   const label = `AID=${this.lam.agentid} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
    //   // const label = `AID=${this.agent.id} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
    //   return {
    //     category: eventCategory && eventCategory.length > 0 ? eventCategory : 'Agent Referral',
    //     action: eventAction,
    //     label
    //   };
    // },
  },
};
